module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("First published in hardback in Great Britain in 2023 by Polygon, an imprint of Birlinn Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Birlinn Ltd"), _c('br'), _vm._v("West Newington House"), _c('br'), _vm._v("10 Newington Road"), _c('br'), _vm._v("Edinburgh"), _c('br'), _vm._v("EH9 1QS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.polygonbooks.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.polygonbooks.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © Alan Warner, 2023")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The right of Alan Warner to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978 1 84697 569 1"), _c('br'), _vm._v("eBook ISBN 978 1 78885 530 3")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Typeset by 3btype, Edinburgh")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0